import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-primary-button',
  imports: [NgClass],
  templateUrl: './ln-primary-button.component.html',
  styleUrl: './ln-primary-button.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnPrimaryButtonComponent {
  @Input({ required: true }) class!: string;
  @Input() label = 'components Primary Button';
  @Output() OnClick = new EventEmitter<void>();
  @Input() showSpinner = false;

  handleClick() {
    if (!this.showSpinner) {
      this.OnClick.emit();
    }
  }
}
